import { post, put } from 'helpers/api';

import { convertTiersToArray } from 'bundles/backoffice/helpers/royalties';

export const SAVE_STARTED = 'SAVE_STARTED';
function saveStarted() {
  return {
    type: SAVE_STARTED,
  };
}

export const SET_SCHEDULE = 'SET_SCHEDULE';
function setSchedule(schedule) {
  return {
    type: SET_SCHEDULE,
    schedule,
  };
}

export const SET_ERRORS = 'SET_ERRORS';
export function setErrors(errors) {
  return {
    type: SET_ERRORS,
    errors,
  };
}

export function saveSchedule(schedule) {
  return (dispatch, getState) => {
    dispatch(saveStarted());

    const { paths } = getState();

    // We want to actually keep the "null" for the top tier, so let's make sure not to drop it in the request
    const body = {
      royaltySchedule: {
        ...schedule,
        tiers: JSON.stringify(convertTiersToArray(schedule.tiers)),
      },
    };

    if (schedule.royaltyPatternName === 'custom') {
      delete body.royaltySchedule.royaltyPatternName;
    } else {
      delete body.royaltySchedule.tiers;
    }

    delete body.royaltySchedule.canEdit;
    delete body.royaltySchedule.filedCommissionAmountYearToDate;
    delete body.royaltySchedule.id;
    delete body.royaltySchedule.numberOfAgents;
    delete body.royaltySchedule.numberOfAgentsPaid;

    let action, path;
    if (schedule.id) {
      action = put;
      path = `${paths.royaltySchedulesBasePath}/${schedule.id}`;
    } else {
      action = post;
      path = paths.royaltySchedulesBasePath;
    }

    return action(path, body)
      .then(({ royaltySchedule }) => {
        dispatch(setErrors([]));
        dispatch(setSchedule(royaltySchedule));
      })
      .catch((errors) => {
        dispatch(setErrors(errors));
      });
  };
}
